import React from 'react';
import { useNavigate } from 'react-router-dom';
import bian from '../../Assets/foto-nutri.webp';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="hero-inner">
        <div className="hero-content">
          <div className="hero-tag">Nutrición funcional</div>
          <h1 className="hero-title">
            Mejorá tu salud<br />desde <em className="deco-underline">la raíz</em>
          </h1>
          <p className="hero-sub">
            Planes personalizados basados en evidencia, con un abordaje integral,
            antiinflamatorio y adaptado a tu historia, tus síntomas y tus objetivos.
          </p>
          <div className="hero-actions">
            <button onClick={() => navigate('/calendar')} className="hero-btn-primary">
              Reservar consulta
            </button>
            <a href="/#about" className="hero-btn-secondary">
              Conocer el método
            </a>
          </div>
          <div className="hero-pills">
            <span className="hero-pill">Presencial y online</span>
            <span className="hero-pill">InBody 120</span>
            <span className="hero-pill">Abordaje integral</span>
          </div>
        </div>

        <div className="hero-photo-area">
          <div className="hero-deco"></div>
          <img
            src={bian}
            alt="Lic. Bianca Angelucci"
            className="hero-photo"
            loading="eager"
            width="800"
            height="841"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
